export default "__VITE_ASSET__B55qvt6$__"